export const BANNER_LIST_REQUEST = 'BANNER_LIST_REQUEST';
export const BANNER_CREATE_REQUEST = 'BANNER_CREATE_REQUEST';
export const BANNER_UPDATE_REQUEST = 'BANNER_UPDATE_REQUEST';
export const BANNER_DELETE_REQUEST = 'BANNER_DELETE_REQUEST';
export const BANNER_SORT_UPDATE_REQUEST = 'BANNER_SORT_UPDATE_REQUEST';

